import { render, staticRenderFns } from "./FormObligationGeneric.vue?vue&type=template&id=3881d50c"
import script from "./FormObligationGeneric.vue?vue&type=script&lang=js"
export * from "./FormObligationGeneric.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports